import React from 'react';
import PropTypes from 'prop-types';
import { ZCDTable } from '@zencity/common-ui';
import classNames from 'classnames';

function StatisticsTable(props) {
  const { question } = props;
  const { datasets } = question.data;
  const hasComparison = datasets.some(
    (dataset) => typeof dataset.statistics.comparisonValue === 'number'
  );

  const renderMean = (dataset) => {
    const { comparisonValue, mean, meanDiff } = dataset.statistics;
    if (typeof comparisonValue !== 'number' || typeof meanDiff !== 'number') return mean;

    return (
      <>
        {mean}
        <span
          className={classNames('engage-results-statistics-table__change', {
            'engage-results-statistics-table__change--positive': meanDiff > 0,
            'engage-results-statistics-table__change--negative': meanDiff < 0,
          })}
        >
          {`${meanDiff >= 0 ? '+' : ''}${meanDiff.toFixed(2)}%`}
        </span>
      </>
    );
  };

  const tableData = question.data.datasets.map((dataset) => ({
    title: dataset.title,
    ...dataset.statistics,
    mean: renderMean(dataset),
  }));

  const columnArray = [
    { Header: 'Line Item', accessor: 'title', width: false },
    { Header: 'Minimum', accessor: 'min', width: false },
    { Header: 'Maximum', accessor: 'max', width: false },
    { Header: 'Median', accessor: 'median', width: false },
    { Header: 'Mean', accessor: 'mean', width: false },
    ...(hasComparison ? [{ Header: 'Comparison', accessor: 'comparisonValue', width: false }] : []),
    { Header: 'Mode', accessor: 'mode', width: false },
    { Header: 'Std. Deviation', accessor: 'stdDev', width: false },
  ];

  return (
    <div>
      <h4 className="engage-results-engagement-screen__chart-content__subtitle">Statistics</h4>
      <ZCDTable columnArray={columnArray} tableData={tableData} maxItemsLimit={10} />
    </div>
  );
}

StatisticsTable.propTypes = {
  question: PropTypes.shape({
    data: PropTypes.shape({
      averages: PropTypes.shape({
        labels: PropTypes.arrayOf(PropTypes.string),
        values: PropTypes.arrayOf(PropTypes.number),
        percentages: PropTypes.arrayOf(PropTypes.number),
      }),
      datasets: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          labels: PropTypes.arrayOf(PropTypes.string),
          counts: PropTypes.arrayOf(PropTypes.number),
          percentages: PropTypes.arrayOf(PropTypes.number),
          statistics: PropTypes.shape({
            min: PropTypes.number,
            max: PropTypes.number,
            median: PropTypes.number,
            mean: PropTypes.number,
            stdDev: PropTypes.number,
            meanDiff: PropTypes.number,
            comparisonValueLabel: PropTypes.string,
            comparisonValue: PropTypes.number,
            mode: PropTypes.number,
          }),
        })
      ),
    }),
  }).isRequired,
};

export default StatisticsTable;
